module.exports = {
	extends: [
		'/',
		'base',
		'mediaManagement',
		'image',
		'image'
	],

	config: {
		listComponentClass: 'base_mediaManagement_image_imageList',
		listElementComponentClass: 'base_form_media_image_image',
		nrOfElementsComponentClass: '',
		listNewElementContainerClass: '.newImages',
		getCategorizedMediaActionName: 'getCategorizedMediaArtImageArchive'
	},

	methods: {
		dataDealer: function () {
			this.model.fieldConfig = this.getResourceRegisterContent('fieldConfig') || {};
			this.model.managementConfig = this.model.fieldConfig.managementConfig || {};
		}
	}
};